import React from 'react';
import DynamicFormSection from '../DynamicFormSection';
import { kitchenConfig } from './kitchenJson';
interface KitchenProps {
  onChange: React.Dispatch<React.SetStateAction<any>>;
  initialValues?: any;
}
const Kitchen: React.FC<KitchenProps> = ({ onChange, initialValues }) => {
  return (
    <>
      {kitchenConfig.map((section) => (
        <DynamicFormSection
          key={section.key}
          config={section}
          initialValue={initialValues?.[section.key]}
          onChange={(value) => {
            onChange((prev) => ({
              ...prev,
              [section.key]: value,
            }));
          }}
        />
      ))}
    </>
  );
};

export default Kitchen;
